<template>
  <div class="wecom-kf-rule" v-loading="loading">
    <el-form label-width="140px" size="small" style="max-width: 760px">
      <el-form-item label="业务规则">
        <el-input v-model="form.ruleText" type="textarea" :rows="12" placeholder="退款、改签、投诉口径，以及禁止推诿和敷衍" />
      </el-form-item>
      <el-form-item label="首响超时（秒）">
        <el-input-number v-model="form.firstResponseTimeoutSeconds" :min="1" :max="86400" />
      </el-form-item>
      <el-form-item label="间隔超时（秒）">
        <el-input-number v-model="form.gapTimeoutSeconds" :min="1" :max="86400" />
      </el-form-item>
      <el-form-item label="模型地址">
        <el-input v-model="form.baseUrl" placeholder="https://api.example.com/v1" />
      </el-form-item>
      <el-form-item label="模型名">
        <el-input v-model="form.model" placeholder="模型名称" />
      </el-form-item>
      <el-form-item label="密钥">
        <el-input v-model="form.apiKey" show-password placeholder="留空则不修改" />
        <div v-if="form.apiKeyMask" class="mask">当前：{{ form.apiKeyMask }}</div>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" :loading="saving" @click="save">保存</el-button>
        <el-button :loading="testing" @click="test">测试模型</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { getWecomKfRule, saveWecomKfRule, testWecomKfRule } from "@/api/wecom_kf";

export default {
  data() {
    return {
      loading: false,
      saving: false,
      testing: false,
      form: {
        ruleText: "",
        firstResponseTimeoutSeconds: 60,
        gapTimeoutSeconds: 180,
        baseUrl: "",
        model: "",
        apiKey: "",
        apiKeyMask: ""
      }
    };
  },
  created() {
    this.load();
  },
  methods: {
    load() {
      this.loading = true;
      getWecomKfRule().then((res) => {
        const data = res.data || {};
        this.form = {
          ruleText: data.ruleText || "",
          firstResponseTimeoutSeconds: data.firstResponseTimeoutSeconds || 60,
          gapTimeoutSeconds: data.gapTimeoutSeconds || 180,
          baseUrl: data.baseUrl || "",
          model: data.model || "",
          apiKey: "",
          apiKeyMask: data.apiKeyMask || ""
        };
      }).finally(() => {
        this.loading = false;
      });
    },
    save() {
      this.saving = true;
      saveWecomKfRule(this.ruleBody()).then((res) => {
        this.form.apiKey = "";
        this.form.apiKeyMask = (res.data && res.data.apiKeyMask) || "";
        this.$message.success("已保存");
      }).finally(() => {
        this.saving = false;
      });
    },
    ruleBody() {
      return {
        ruleText: this.form.ruleText,
        firstResponseTimeoutSeconds: this.form.firstResponseTimeoutSeconds,
        gapTimeoutSeconds: this.form.gapTimeoutSeconds,
        baseUrl: this.form.baseUrl,
        model: this.form.model,
        apiKey: this.form.apiKey
      };
    },
    test() {
      this.testing = true;
      testWecomKfRule(this.ruleBody()).then((res) => {
        this.$message.success("模型可用：" + (res.data || "OK"));
      }).finally(() => {
        this.testing = false;
      });
    }
  }
};
</script>

<style scoped>
.mask {
  color: #909399;
  font-size: 12px;
}
</style>
